import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const schema = yup
  .object({
    name: yup
      .string()
      .trim()
      .required('Name is required')
      .min(1, 'Name must be at least 1 character'),
    site: yup.object().nullable().required('Site is required'),
  })
  .required()

const resAddCenter = yupResolver(schema)

export default resAddCenter
